'use client'

import React, { useEffect, useState } from 'react';

const BeautyServices = () => {
  const [dynamicTop, setDynamicTop] = useState('-165px'); // Default top margin
  const [buttonMarginBottom, setButtonMarginBottom] = useState('0px'); // Default button margin

  useEffect(() => {
    const updateLayout = () => {
      if (window.innerWidth < 768) {
        setDynamicTop('-95px'); // Adjust top margin for small screens
        setButtonMarginBottom('55px'); // Add margin below button on small screens
      } else {
        setDynamicTop('-115px'); // Default for larger screens
        setButtonMarginBottom('45px'); // Remove extra margin for larger screens
      }
    };

    updateLayout(); // Call on component mount
    window.addEventListener('resize', updateLayout); // Update on window resize

    return () => {
      window.removeEventListener('resize', updateLayout); // Cleanup on component unmount
    };
  }, []);

  const styles = {
    container: {
      fontFamily: 'Robots, sans-serif',
      position: 'relative',
      top: dynamicTop, // Use dynamic top margin
      margin: '0 auto',
      maxWidth: '1200px',
      padding: '40px 20px',
    },
    layout: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: '20px',
      flexWrap: 'wrap',
    },
    imageSection: {
      flex: '1 1 30%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: 'auto', // Increased height for the circle
      width: 'auto', // Set the width equal to the height for a circular shape
      overflow: 'hidden', // Ensures the image stays inside the circle bounds
    },
    image: {
      width: '100%', // Make the image fill the container width
      height: '100%', // Make the image fill the container height
      borderRadius: '50%', // This makes the image circular
      objectFit: 'cover', // Ensure the image covers the entire area without distortion
    },
    servicesSection: {
      flex: '1 1 30%',
    },
    serviceItem: {
      border: '1px solid #e0e0e0',
      borderRadius: '12px',
      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
      padding: '20px',
      marginBottom: '20px',
      background: '#ffffff',  /* Set background color to white */
      textAlign: 'center',
      transition: 'transform 0.3s ease',
    },
    serviceTitle: {
      fontSize: '1.4rem',
      color: '#000000',  /* Black text color */
      margin: '15px 0 10px',
    },
    serviceDescription: {
      fontSize: '1rem',
      color: '#000000',  /* Black text color */
      lineHeight: '1.5',
      margin: '0 0 10px',
    },
    callToAction: {
      textAlign: 'center',
      marginTop: '40px',
    },
    button: {
      backgroundColor: '#ff7f5f',
      color: '#fff',
      border: 'none',
      padding: '12px 30px',
      fontSize: '1rem',
      fontWeight: 'bold',
      borderRadius: '6px',
      cursor: 'pointer',
      transition: 'background-color 0.3s ease',
      marginBottom: buttonMarginBottom, // Dynamic margin for button
    },
    buttonHover: {
      backgroundColor: '#ff5635',
    },
  };
  

  return (
    <>
      <div className="bg-gray-100 lg:py-16 py-10 lg:-mt-44 -mt-24" style={{marginTop:'4px'}}>
        <div className="mx-auto max-w-screen-2xl px-3 sm:px-10">
          <div className="mb-10 flex justify-center">
            <div className="text-center w-full lg:w-5/5">
              {/* <h2 className="font-serif font-semibold"> */}

              <h2 style={{
                fontSize: '1.4rem',
                color: '#000000', /* Black text color */
                fontFamily: 'Robots, sans-serif',
                lineHeight: '1.6',
                marginBottom:'2px'
              }}  className="text-xl lg:text-2xl mb-2 font-semibold">


                Our Complete 360° Beauty Parlour Services at Your Home
              </h2>
              <p style={{
                fontSize: '1rem',
                color: '#000000', /* Black text color */
                fontFamily: 'Robots, sans-serif',
                lineHeight: '1.5',
                textAlign: 'center', /* Center the text inside the block */
                margin: '0 0 10px',
              }}
              className="text-base leading-6 text-justify justify-center"
              >
                Beauty & Quality Products - Trusted and Well Trained Professionals - Pocket-Friendly Rates - Full Safety, Hygiene & Satisfaction - Women Only
              </p>
            </div>
          </div>
        </div>
      </div>

      <div style={styles.container}>
        <div style={styles.layout}>
          <div style={styles.servicesSection}>
            <div style={styles.serviceItem}>
              <h3 style={styles.serviceTitle}>Head & Body Massages</h3>
              <p style={styles.serviceDescription}>
                Relax with professional head and body massages that rejuvenate your body.
              </p>
            </div>
            <div style={styles.serviceItem}>
              <h3 style={styles.serviceTitle}>Hair Expert Services</h3>
              <p style={styles.serviceDescription}>
                Professional hair care solutions including cutting, styling, and coloring for a stunning.
              </p>
            </div>
            <div style={styles.serviceItem}>
              <h3 style={styles.serviceTitle}>Polish & Grooming</h3>
              <p style={styles.serviceDescription}>
                Full grooming services including manicure, pedicure, and more for your complete beauty.
              </p>
            </div>
          </div>

          <div style={styles.imageSection}>
            <img style={styles.image} src="assets/Company/Image2.jpeg" alt="Illustration" />
          </div>

          <div style={styles.servicesSection}>
            <div style={styles.serviceItem}>
              <h3 style={styles.serviceTitle}>Makeup & Parties</h3>
              <p style={styles.serviceDescription}>
                Get party-ready with professional makeup services tailored to your preferences.
              </p>
            </div>
            <div style={styles.serviceItem}>
              <h3 style={styles.serviceTitle}>Waxing & Threading</h3>
              <p style={styles.serviceDescription}>
                Smooth and flawless skin with professional waxing and threading services.
              </p>
            </div>
            <div style={styles.serviceItem}>
              <h3 style={styles.serviceTitle}>Bridal & Events</h3>
              <p style={styles.serviceDescription}>
                Look stunning on your big day with our specialized bridal and event beauty packages.
              </p>
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'center', width: '100%', marginTop: '-30px' }}>
          <div style={styles.callToAction}>
            <button
              className="py-2 px-4 rounded-lg !text-white !no-underline !bg-pink-600 hover:!bg-emerald-600 flex items-center justify-center bg-heading text-sm focus:outline-none transition duration-300"
              style={{
                ...styles.button,
                padding: '8px 16px',
                fontFamily: 'Robots, sans-serif',
                fontSize: '0.875rem',
                width: 'auto',
              }}
              
              onMouseOver={(e) => (e.target.style.backgroundColor = styles.buttonHover.backgroundColor)}
              onMouseOut={(e) => (e.target.style.backgroundColor = styles.button.backgroundColor)}
            >
              Book Your Appointment
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default BeautyServices;
